import { render, staticRenderFns } from "./PUListLoader.vue?vue&type=template&id=412639c4&scoped=true"
import script from "./PUListLoader.vue?vue&type=script&lang=js"
export * from "./PUListLoader.vue?vue&type=script&lang=js"
import style0 from "./PUListLoader.vue?vue&type=style&index=0&id=412639c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412639c4",
  null
  
)

export default component.exports